import './App.css';

const values = [
  { letter: 'S', text: 'Steadfast in Purpose' },
  { letter: 'H', text: 'Honest in all that I do and Say' },
  { letter: 'I', text: 'Integrity at the core of my life' },
  { letter: 'N', text: 'Never wavering from my convictions' },
  { letter: 'E', text: 'Eager to share…eager to serve…Just like Jesus' },
];

const uniqueness = [
  { icon: '🎓', text: 'Competent and qualified staff' },
  { icon: '🌾', text: 'School-owned farm' },
  { icon: '🏫', text: 'Permanent structures & conducive learning environment' },
  { icon: '💧', text: 'Permanent water supply system' },
  { icon: '✝️', text: 'Children raised in the fear of God' },
  { icon: '💰', text: 'Friendly and affordable fee structure' },
];

export default function App() {
  return (
    <>
      {/* NAV */}
      <nav>
        <a href="#home" className="nav-logo">
          <img src="/Sonshine logo.png" alt="Sonshine Logo" />
          <span>SonShine<br />Christian Schools</span>
        </a>
        <ul>
          <li><a href="#about">About</a></li>
          <li><a href="#mission">Mission</a></li>
          <li><a href="#values">Values</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#locations">Locations</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>

      {/* HERO */}
      <section className="hero" id="home" style={{ background: `linear-gradient(135deg, rgba(26,26,46,0.85) 0%, rgba(22,33,62,0.75) 100%), url('${process.env.PUBLIC_URL}/IMG-7558.jpg') center/cover no-repeat` }}>
        <div className="hero-content">
          <img src="/Sonshine logo.png" alt="Sonshine Logo" />
          <h1>SonShine Christian Schools</h1>
          <p className="motto">"Transformed to Transform"</p>
          <p>
            Quality Christian education for the next generation — nurturing
            character, faith, and academic excellence in Uganda.
          </p>
          <a href="#about" className="btn">Discover Our Story</a>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about" id="about">
        <h2>About Us</h2>
        <p className="section-intro">
          SonShine Christian Schools are private, mixed day-and-boarding schools
          offering both High School and Primary education with quality learning.
        </p>
        <div className="about-grid">
          <img src="/IMG-7561.jpg" alt="School campus" />
          <div className="about-text">
            <p>
              Our High School is located in <strong>Bugweri District</strong> (formerly Iganga),
              while our Primary School serves the West Nile region in <strong>Koboko District</strong>.
            </p>
            <p>
              We were founded primarily to serve orphans and vulnerable children sponsored
              by <strong>KIDS IN Uganda</strong> — an NGO operating since 2011 — while also
              welcoming children from the wider community.
            </p>
            <p>
              KIDS IN Uganda's vision is a community free from hunger, poverty, illiteracy,
              and preventable diseases, with SonShine Schools as a cornerstone of that mission.
            </p>
            <p>
              Our High School is fully licensed with the Ministry of Education and Sports
              for both O-Level and A-Level programmes.
            </p>
          </div>
        </div>
      </section>

      {/* MISSION / VISION */}
      <section id="mission">
        <h2>Mission & Vision</h2>
        <p className="section-intro">
          Everything we do is guided by a clear purpose and a bold vision for our students and nation.
        </p>
        <div className="mv-grid">
          <div className="mv-card">
            <div className="icon">🎯</div>
            <h3>Our Mission</h3>
            <p>
              Passionately committed to our students — each will complete their studies
              prepared, with strong character, ready to live lives of purpose and significance.
            </p>
          </div>
          <div className="mv-card">
            <div className="icon">👁️</div>
            <h3>Our Vision</h3>
            <p>
              To see transformed individuals seeking to bring transformation to the nation.
            </p>
          </div>
          <div className="mv-card">
            <div className="icon">✨</div>
            <h3>Our Motto</h3>
            <p>
              <em>"Transformed to Transform"</em> — we believe every student carries the
              potential to change their community and country.
            </p>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="values" id="values">
        <h2>Core Values</h2>
        <p className="section-intro" style={{ color: '#aaa' }}>
          The word <strong style={{ color: '#c9a84c' }}>SHINE</strong> captures the five
          pillars that define our school culture.
        </p>
        <div className="values-list">
          {values.map(({ letter, text }) => (
            <div className="value-item" key={letter}>
              <span className="bullet">{letter}</span>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* UNIQUENESS */}
      <section id="uniqueness">
        <h2>What Makes Us Unique</h2>
        <p className="section-intro">
          We go beyond academics to provide a holistic, faith-centred environment.
        </p>
        <div className="unique-grid">
          {uniqueness.map(({ icon, text }) => (
            <div className="unique-card" key={text}>
              <div className="icon">{icon}</div>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* GALLERY */}
      <section className="gallery" id="gallery">
        <h2>Gallery</h2>
        <p className="section-intro">A glimpse into life at SonShine Christian Schools.</p>
        <div className="gallery-grid">
          <img src={`${process.env.PUBLIC_URL}/IMG-7558.jpg`} alt="School grounds" />
          <img src={`${process.env.PUBLIC_URL}/IMG-7561.jpg`} alt="School campus" />
          <img src={`${process.env.PUBLIC_URL}/IMG-7562.jpg`} alt="School facilities" />
          <img src={`${process.env.PUBLIC_URL}/IMG-7565.jpg`} alt="School environment" />
          <img src={`${process.env.PUBLIC_URL}/_DSC1953.JPG.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC5661.JPG-1.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC6429.JPG-2.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC6432.JPG-2.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC6491.JPG-1.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC7539.JPG-1.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC7577.JPG-1.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/_DSC9570 A3 copy.jpg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/IMG_9011.jpeg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/IMG_9013.jpeg`} alt="School life" />
          <img src={`${process.env.PUBLIC_URL}/IMG_9020.jpeg`} alt="School life" />
        </div>
      </section>

      {/* LOCATIONS */}
      <section id="locations">
        <h2>Our Locations</h2>
        <p className="section-intro">Two campuses serving different regions of Uganda.</p>
        <div className="locations-grid">
          <div className="location-card">
            <h3>🏫 Primary School</h3>
            <p>
              <strong>Koboko District</strong><br />
              South Division, Nyangilia Parish<br />
              Ainga Village<br />
              P.O. Box 40, Koboko
            </p>
          </div>
          <div className="location-card">
            <h3>🎓 High School</h3>
            <p>
              <strong>Bugweri District</strong> (formerly Iganga)<br />
              Makuutu Sub County<br />
              Bunalwenyi Village<br />
              P.O. Box 119, Iganga
            </p>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact" id="contact">
        <h2>Contact Us</h2>
        <p className="section-intro" style={{ color: '#aaa', margin: '12px auto 0' }}>
          We'd love to hear from you. Reach out to either of our campuses.
        </p>
        <div className="contact-info">
          <div className="contact-item">
            <span className="icon">📞</span>
            <span>+256 039 217 6788</span>
          </div>
          <div className="contact-item">
            <span className="icon">📞</span>
            <span>+256 039 217 7755</span>
          </div>
          <div className="contact-item">
            <span className="icon">📍</span>
            <span>Koboko & Bugweri Districts, Uganda</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <p>© {new Date().getFullYear()} <span>SonShine Christian Schools</span>. A programme of KIDS IN Uganda.</p>
      </footer>
    </>
  );
}
